/*
 * Preço VIP (cupom). Carregado em todas as páginas por layout/theme.liquid quando o
 * preço VIP está ativo (Configurações do tema > Página VIP); a configuração vem em
 * window.vipPricingSettings.
 *
 *  - VipPricing.validate(): valida a senha VIP salva no navegador no servidor
 *    (sections/api-vip-check.liquid), que devolve o cupom e os IDs dos produtos VIP.
 *    O resultado fica alguns minutos em sessionStorage para não repetir a cada página
 *  - VipPricing.syncCoupon(): mantém o cupom VIP no carrinho só quando há item VIP
 *    nele; sem item VIP o cupom sai (evita aviso de cupom não aplicável no checkout).
 *    Roda ao carregar a página e a cada mudança no carrinho; quando o cupom muda e o
 *    carrinho lateral está aberto, ele é recarregado para mostrar o preço VIP
 *  - <vip-price> (snippets/vip-price-tag.liquid): na página de um produto VIP, troca
 *    o preço pelo preço com o cupom (sem tag visível). Recalcula ao trocar de
 *    variante; PIX, parcela e selo de % OFF seguem o preço exibido (assets/custom.js)
 *
 * Só age para quem entrou na área VIP neste navegador (senha salva por
 * assets/vip-access.js). O preço exibido é a conta do cupom; quem garante o desconto
 * no checkout é o cupom no carrinho.
 */
(function () {
  if (window.VipPricing) return;

  const config = Object.assign(
    { searchUrl: '/search', storageKey: 'vip-access', checkSectionId: 'api-vip-check' },
    window.vipPricingSettings || {}
  );
  const CACHE_KEY = 'vip-pricing-check';
  const CACHE_TTL = 5 * 60 * 1000;

  function normalizeCode(code) {
    return String(code || '').trim().toLowerCase();
  }

  function getSavedPassword() {
    try {
      return window.localStorage.getItem(config.storageKey) || '';
    } catch (error) {
      return '';
    }
  }

  function readCache(password) {
    try {
      const cached = JSON.parse(window.sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && cached.password === password && Date.now() - cached.time < CACHE_TTL) {
        return cached.result;
      }
    } catch (error) {}
    return undefined;
  }

  function writeCache(password, result) {
    try {
      window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ password, result, time: Date.now() }));
    } catch (error) {}
  }

  function clearCache() {
    try {
      window.sessionStorage.removeItem(CACHE_KEY);
    } catch (error) {}
    validation = null;
  }

  // Resultado: { code, percent, productIds } ou null (sem senha, senha errada ou preço VIP desligado)
  let validation = null;

  function validate() {
    const password = getSavedPassword();
    if (!password) return Promise.resolve(null);

    const cached = readCache(password);
    if (cached !== undefined) return Promise.resolve(cached);

    if (!validation) {
      const params = new URLSearchParams({ q: password, type: 'product', section_id: config.checkSectionId });
      validation = fetch(`${config.searchUrl}?${params.toString()}`, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      })
        .then((r) => (r.ok ? r.text() : Promise.reject(new Error(`HTTP ${r.status}`))))
        .then((html) => {
          const status = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-vip-status]');
          let result = null;
          if (status && status.dataset.vipStatus === 'granted') {
            result = {
              code: status.dataset.vipCode || '',
              percent: parseFloat(status.dataset.vipPercent) || 0,
              productIds: (status.dataset.vipProducts || '').split(',').filter(Boolean).map(Number),
            };
            if (!result.code || result.percent <= 0) result = null;
          }
          writeCache(password, result);
          return result;
        })
        .catch((error) => {
          console.warn('[vip-pricing]', error);
          return null;
        })
        .finally(() => {
          validation = null;
        });
    }
    return validation;
  }

  function refreshCartDrawer() {
    // getCart() sempre abre o carrinho lateral: só recarrega se ele já está aberto (ou na página do carrinho)
    const cart = window.cart;
    if (cart && typeof cart.getCart === 'function' && (cart.isCartDrawerOpen || cart.isCartPage)) {
      cart.getCart();
    }
  }

  async function setCartCodes(buildCodes) {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
    const current = (cart.discount_codes || []).map((discount) => discount.code);
    const next = buildCodes(current, cart);
    if (next.join(',') === current.join(',')) return false;

    await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: next.join(',') }),
    });

    refreshCartDrawer();
    return true;
  }

  // Cupom no carrinho só com item VIP nele; os demais cupons (ex.: brinde) ficam como estão
  let syncing = null;
  let syncAgain = false;

  function syncCoupon() {
    if (syncing) {
      syncAgain = true;
      return syncing;
    }

    syncing = validate()
      .then((vip) => {
        if (!vip) return false;
        const code = normalizeCode(vip.code);
        return setCartCodes((current, cart) => {
          const others = current.filter((item) => normalizeCode(item) !== code);
          const hasVipItem = (cart.items || []).some((item) => vip.productIds.indexOf(item.product_id) !== -1);
          return hasVipItem ? others.concat(vip.code) : others;
        });
      })
      .catch((error) => {
        console.warn('[vip-pricing]', error);
        return false;
      })
      .finally(() => {
        syncing = null;
        if (syncAgain) {
          syncAgain = false;
          syncCoupon();
        }
      });

    return syncing;
  }

  // Sair da área VIP: tira o cupom do carrinho
  function removeCoupon(code) {
    clearCache();
    if (!normalizeCode(code)) return Promise.resolve(false);
    return setCartCodes((current) => current.filter((item) => normalizeCode(item) !== normalizeCode(code))).catch((error) => {
      console.warn('[vip-pricing]', error);
      return false;
    });
  }

  // Mesma conta do cupom percentual no checkout (centavos, arredondado)
  function vipPrice(price, percent) {
    return price - Math.round((price * percent) / 100);
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  window.VipPricing = { validate, syncCoupon, removeCoupon, clearCache, vipPrice, formatMoney };

  // Mudanças no carrinho (adicionar, remover, alterar quantidade)
  let syncTimer;
  ['theme:cart:added', 'theme:cart:update', 'ajaxify:updated'].forEach((eventName) => {
    document.addEventListener(eventName, () => {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(syncCoupon, 150);
    });
  });

  if (getSavedPassword()) {
    syncCoupon();
  }

  class VipPrice extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      this.variant = {
        price: parseInt(this.dataset.price, 10) || 0,
        compare_at_price: parseInt(this.dataset.compareAtPrice, 10) || 0,
      };

      if (!getSavedPassword()) return;

      // Só a seção do produto: quick view e outros blocos têm os mesmos data-attributes
      this.scope = this.closest('[data-section-id]') || document;
      document.documentElement.classList.add('vip-price-pending');
      validate()
        .then((vip) => {
          if (!vip) return;
          this.percent = vip.percent;
          this.hidden = false;
          this.render(this.variant);
          document.addEventListener('theme:variant:change', this.onVariantChange);
        })
        .finally(() => {
          document.documentElement.classList.remove('vip-price-pending');
        });
    }

    disconnectedCallback() {
      document.removeEventListener('theme:variant:change', this.onVariantChange);
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      this.variant = variant;
      // O tema escreve o preço normal no mesmo evento; reescreve em seguida
      setTimeout(() => this.render(variant), 0);
    }

    render(variant) {
      if (!variant || !variant.price) return;

      const price = variant.price;
      const compare = variant.compare_at_price > price ? variant.compare_at_price : price;
      const finalPrice = vipPrice(price, this.percent);

      this.scope.querySelectorAll('[data-product-price]').forEach((el) => {
        el.textContent = formatMoney(finalPrice);
        el.classList.add('product__price--sale');
      });

      this.scope.querySelectorAll('[data-compare-price]').forEach((el) => {
        el.textContent = formatMoney(compare);
        el.classList.remove('hidden');
      });

      // Selo "% OFF" do bloco de preço (o custom.js também recalcula ao trocar variante)
      const percentOff = Math.round(((compare - finalPrice) / compare) * 100);
      this.scope.querySelectorAll('[data-discount-badge]').forEach((el) => {
        el.textContent = `${percentOff}% OFF`;
        el.style.display = 'inline-flex';
      });
      this.scope.querySelectorAll('.product__price-discount-wrapper').forEach((el) => {
        el.style.display = 'flex';
      });

      // Selo "OFF" do compre rápido (theme.js escreve só o desconto do preço "de"):
      // mesma regra dos cards, com o desconto total já com o cupom
      const badgeType = window.theme && window.theme.settings && window.theme.settings.savingBadgeType;
      this.scope.querySelectorAll('[data-price-off-amount]').forEach((el) => {
        el.textContent = badgeType === 'percentage' ? `${Math.floor(((compare - finalPrice) / compare) * 100)}%` : formatMoney(compare - finalPrice);
      });
      this.scope.querySelectorAll('[data-price-off]').forEach((el) => {
        el.classList.remove('hidden');
      });
    }
  }

  if (!customElements.get('vip-price')) {
    customElements.define('vip-price', VipPrice);
  }
})();
